import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/app-config.service';
import { CommonService } from 'src/app/common.service';
import { ConfigureService } from 'src/app/configuration/configure.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit, OnDestroy {
  roleSubscription: Subscription | undefined;
  places: any = [];
  selectedRole: any;
  currentModule: any;
  viewerOpenPlace: any;
  selectedPlace: string = '';
  appConfig: any;
  licenseInfo: any = null;
  licenseDueDays: number = 0;
  licenseSeverityClass: string = '';
  showLicenseAlert: boolean = false;

  constructor(public router: Router, public commonService: CommonService, private configureService: ConfigureService, private readonly configService: AppConfigService
  ) { this.appConfig = configService.config; }

  ngOnInit(): void {
    this.updateLicenseStatus(this.commonService.ProjectLSData?.currentLicenseStatus);

    if (this.commonService.isLicenseFeatureEnabled()) {
      this.commonService.startLicenseStatusPolling();
      this.commonService.currentLicenseStatus.subscribe((status: any) => {
        this.updateLicenseStatus(status);
      });
    }

    this.roleSubscription = this.commonService.currentRole?.subscribe(role => {
      if (role !== this.selectedRole) {
        this.selectedRole = role;
        if (!this.appConfig?.offlinePlaces) {
          this.commonService.getRolePlaces(this.selectedRole).subscribe((result: any) => {
            if (result.data.places.length) {
              this.places = [];
              result.data.places.forEach((item: any) => {
                this.places.push({
                  'displayName': item,
                  'moduleName': item == "Analysis" ? "analysis" : item.toLowerCase(),
                  'isVisible': true
                });
              });
              if (!this.commonService.ProjectLSData.userActivePlace) {
                let landingPageInfo = this.commonService.getUserRoleLandingPage(this.selectedRole);
                this.router.navigate([`/mainboard/${landingPageInfo.landingPage}`]);
                this.commonService.ProjectLSData.userActivePlace = this.selectedPlace = landingPageInfo.userActivePlace;
                this.commonService.setProjectLSData();
              } else {
                this.selectedPlace = this.commonService.ProjectLSData.userActivePlace;
              }
            }
          });
        } else {
          this.places = [];
          this.appConfig?.roleWisePlaces?.[this.selectedRole]?.forEach((element: any) => {
            this.places.push({
              'displayName': element,
              'moduleName': element == "Analysis" ? "analysis" : element.toLowerCase(),
              'isVisible': true
            });
          });
          if (!this.commonService.ProjectLSData.userActivePlace) {
            let landingPageInfo = this.commonService.getUserRoleLandingPage(this.selectedRole);
            this.router.navigate([`/mainboard/${landingPageInfo.landingPage}`]);
            this.commonService.ProjectLSData.userActivePlace = this.selectedPlace = landingPageInfo.userActivePlace;

            this.commonService.setProjectLSData();
          } else {
            this.selectedPlace = this.commonService.ProjectLSData.userActivePlace;
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.roleSubscription?.unsubscribe();
  }

  updateLicenseStatus(status: any) {
    this.licenseInfo = status;
    const dueInfo = this.commonService.getLicenseDueInfo(status);
    this.licenseDueDays = dueInfo.dueDays;
    this.licenseSeverityClass = dueInfo.severityClass;
    this.showLicenseAlert = dueInfo.shouldShow;
  }

  changePlace(place: any) {
    // restrict duplicate api calls
    if (place == this.selectedPlace) {
      return;
    }
    if (place == 'configure') {
      this.router.navigate(['mainboard/' + 'configure']);
    } else if (place == 'users') {
      this.router.navigate(['mainboard/' + 'users']);
    } else if (place == 'gallery') {
      this.configureService.getConfigData().subscribe((result: any) => {
        if (result.success) {
          this.commonService.ProjectLSData.qcProcess = result.data?.qcMode;
          this.commonService.setProjectLSData();
        }
      });
      this.router.navigate(['mainboard/' + 'gallery/' + this.commonService.ProjectLSData?.activeGalleryTab]);
    } else if (place == 'dashboard') {
      this.router.navigate(['mainboard/' + 'dashboard']);
    } else if (place == 'analysis') {
      this.router.navigate(['mainboard/' + 'analysis']);
    } else if (place == 'upload') {
      this.router.navigate(['mainboard/' + 'upload']);
    } else if (place == 'reports') {
      this.router.navigate(['mainboard/' + 'reports']);
    }
    this.selectedPlace = place;
    this.commonService.setCurrentPlace(this.selectedPlace);
  }

  getCurrentPlace() {
    this.commonService.currentPlace.subscribe((currentPlace: any) => {
      this.selectedPlace = currentPlace;
    })
  }

}
